import { END_USER_MOBILE_FRAME_WIDTH_PX } from 'constants/endUserMobileLayout';

import { styled } from '@mui/material/styles';

import { colors } from 'theme/colors';

/** Keeps the FAB aligned to the 375px end-user frame on desktop. */
export const EndUserSupportFabAnchor = styled('div')`
  position: fixed;
  inset: 0;
  z-index: 1100;
  pointer-events: none;
  max-width: ${END_USER_MOBILE_FRAME_WIDTH_PX}px;
  width: 100%;
  margin: 0 auto;
`;

export const EndUserSupportFabButton = styled('button')`
  pointer-events: auto;
  position: absolute;
  right: 20px;
  bottom: 34px;
  width: 44px;
  height: 44px;
  margin: 0;
  padding: 0;
  border: none;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.button.dark};
  color: ${colors.background.main};
  box-shadow: 0 4px 12px rgba(19, 19, 20, 0.2);
  cursor: pointer;

  &:hover {
    background-color: ${colors.button.dark};
    filter: brightness(0.96);
  }

  &:focus-visible {
    outline: 2px solid ${colors.button.dark};
    outline-offset: 3px;
  }
`;
